module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-input-money",
    on: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }, [_c('el-input', {
    ref: "inputMoney",
    attrs: {
      "placeholder": _vm.computedInputPlaceholder,
      "readonly": _vm.readonly,
      "disabled": _vm.computedDisabled,
      "type": "text"
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blurHandler,
      "change": _vm.changeHandler
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, [(_vm.$scopedSlots.prefix) ? _c('span', {
    staticClass: "prefix",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_vm._t("prefix")], 2) : _vm._e(), _vm._v(" "), _vm._t("prepend", null, {
    "slot": "prepend"
  }), _vm._v(" "), _vm._t("append", null, {
    "slot": "append"
  })], 2), _vm._v(" "), (!_vm.computedDisabled && !_vm.showClose && _vm.showSuffixIcon) ? _c('rt-icon', {
    attrs: {
      "color": _vm.SCSS_VARIABLES.NEUTRAL_COLOR_SECONDARY,
      "name": "rt-base-record-lined"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    staticClass: "rt-xpc-input-clearicon",
    style: (_vm.computedClearIconStyle),
    attrs: {
      "slot": "suffix",
      "name": _vm.computedIconName,
      "color": _vm.SCSS_VARIABLES.COLOR_SECONDARY
    },
    on: {
      "click": _vm.clear
    },
    slot: "suffix"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-531d4736"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtInputMoney.vue
// module id = 2145
// module chunks = 137